import { useAclContext } from '../../../contexts/acl'
import { useNavigate, useParams } from 'react-router-dom'
import { useState } from 'react'
import { dueTransactionOperations, transactionOperations } from '../../../constants/operation'

const useBankTransactions = (isDue = false) => {
	const params = useParams()
	const navigate = useNavigate()
	const { permissions } = useAclContext()
	const hasWriteAccess = permissions.banking?.write

	const modalInitial = {
		action: null,
		open: false,
		transaction: null,
		type: 'banking',
	}
	const [modal, setModal] = useState(modalInitial)

	const onDetailsClicked = (transaction) => {

		if (isDue) {
			navigate(`/reports/due-transactions/${transaction._id}`)
		} else {
			if (params.tab) navigate(`/users/${params.id}/${params.tab}/${transaction._id}`)
			else navigate(`/reports/bank-transactions/${transaction._id}`)
		}
	}

	const onOptionClicked = (idx, transaction, isManual) => {
		setModal({
			open: true,
			action: transactionOperations[idx],
			transaction,
			type: 'banking',
			isManual,
			isDue
		})
	}

	const onModalClose = () => {
		if (modal.open) {
			setModal(modalInitial)
		}
	}

	const getTransactionOptions = (transaction, isManual) => {
		if (isDue && transaction.status === 'pending') {
			return dueTransactionOperations
		}
		if (isDue && transaction.status !== 'pending') {
			return [...dueTransactionOperations, ["pending"]]
		}
		if (isManual && transaction.status === 'pending') {
			return transactionOperations
		}
		if (!isManual && transaction?.status === 'pending' && transaction?.flow === 'withdraw') {
			return transactionOperations
		}
		return []
	}

	return {
		hasWriteAccess,
		onDetailsClicked,
		onOptionClicked,
		modal,
		onModalClose,
		getTransactionOptions,
	}
}

export default useBankTransactions
